// extracted by mini-css-extract-plugin
export var actionButton = "_b6-1";
export var actionButtons = "_b6-2";
export var actions = "_b6-0";
export var aiUnread = "_b6-10";
export var alignCenter = "_b6-h";
export var backWrapper = "_b6-3";
export var cellContainer = "_b6-4";
export var checkboxContainer = "_b6-5";
export var contentContainer = "_b6-6";
export var contentHeader = "_b6-8";
export var conversationsTableWrapper = "_b6-s";
export var draftReplyBadgeContainer = "_b6-m";
export var dropdownItem = "_b6-b";
export var dropdownItemsContainer = "_b6-a";
export var dropdownTitle = "_b6-c";
export var errorIcon = "_b6-7";
export var filter = "_b6-d";
export var gray = "_b6-i";
export var headerActionButtons = "_b6-e";
export var headerCheckboxContainer = "_b6-f";
export var icon = "_b6-j";
export var menuContainer = "_b6-k";
export var noMoreTicketsIcon = "_b6-12";
export var noMoreTicketsSubText = "_b6-13";
export var oneLine = "_b6-l";
export var optionsButton = "_b6-n";
export var plus = "_b6-o";
export var portalButtonsWrapper = "_b6-g";
export var red = "_b6-p";
export var scrolledTop = "_b6-9";
export var search = "_b6-q";
export var selectedConversationsCount = "_b6-r";
export var spinner = "_b6-t";
export var strong = "_b6-u";
export var summaryCell = "_b6-v";
export var tableContainer = "_b6-11";
export var tagContainer = "_b6-w";
export var threeDots = "_b6-x";
export var twoLines = "_b6-y";
export var unread = "_b6-z";